import { makeStyles, useTheme } from '@material-ui/core';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import * as React from 'react';
const useStyles = makeStyles((theme) => ({
  root: {
    userSelect: 'none',
    width: '1em',
    height: '1em',
    display: 'inline-block',
    fill: 'currentColor',
    flexShrink: 0,
    transition: theme.transitions.create('fill', {
      duration: theme.transitions.duration.shorter,
    }),
  },
}));

function SvgPicCirclePriceMonthlyUnselected({ svgRef, ...props }) {
  const classes = useStyles();
  const theme = useTheme();
  const { color, className } = props;
  return (
    <svg
      {...props}
      viewBox="0 0 56 56"
      className={classnames(classes.root, className)}
      color={theme.colors[color] ?? color}
      ref={svgRef}
    >
      <g fill="none" fillRule="evenodd">
        <circle fill="#999" cx={28} cy={28} r={28} />
        <g transform="translate(16 16.4)">
          <path d="M1.5 2.933h21a1.5 1.5 0 011.5 1.5v4.5H0v-4.5a1.5 1.5 0 011.5-1.5z" fill="#FFF" />
          <rect fill="#CCC" x={4} width={4} height={6} rx={0.3} />
          <rect fill="#CCC" x={16} width={4} height={6} rx={0.3} />
          <path d="M0 10.2h24v11.5a1.5 1.5 0 01-1.5 1.5h-21A1.5 1.5 0 010 21.7V10.2z" fill="#FFF" />
          <path
            d="M7.7 17.7a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3H4.3a.3.3 0 01-.3-.3V18a.3.3 0 01.3-.3h3.4zm6 0a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3h-3.4a.3.3 0 01-.3-.3V18a.3.3 0 01.3-.3h3.4zm6 0a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3h-3.4a.3.3 0 01-.3-.3V18a.3.3 0 01.3-.3h3.4zm-12-5a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3H4.3a.3.3 0 01-.3-.3V13a.3.3 0 01.3-.3h3.4zm6 0a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3h-3.4a.3.3 0 01-.3-.3V13a.3.3 0 01.3-.3h3.4zm6 0a.3.3 0 01.3.3v2.4a.3.3 0 01-.3.3h-3.4a.3.3 0 01-.3-.3V13a.3.3 0 01.3-.3h3.4z"
            fill="#CCC"
          />
        </g>
      </g>
    </svg>
  );
}

SvgPicCirclePriceMonthlyUnselected.propTypes = {
  svgRef: PropTypes.any,
  className: PropTypes.string,
  color: PropTypes.string,
  fontSize: PropTypes.any,
};
SvgPicCirclePriceMonthlyUnselected.defaultProps = {
  svgRef: undefined,
  className: undefined,
  color: undefined,
  fontSize: 16,
};
const ForwardRef = React.forwardRef((props, ref) => (
  <SvgPicCirclePriceMonthlyUnselected svgRef={ref} {...props} />
));
export default ForwardRef;
